import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
const MAX_NAME_LENGTH = 10;

export default function ParametersDropdown(props) {
    function getOptions() {
        let options = props.parameters.map(
            param => getSelectedOption(param));

        return [{label: 'None', value: null}, ... options];
    }

    function getSelectedOption(parameter=props.parameter) {
        if (parameter === undefined) {
            return undefined;
        }
        return {
            value: parameter,
            label: parameter
        };
    }

    let className = props.className ?
        props.className + ' tracks-dropdown-container' :
        'tracks-dropdown-container';

    return (
        <div
          className={className}>
          <Dropdown
            className='osc-type-dropdown'
            controlClassName='osc-type-control-dropdown'
            arrowClassName='osc-type-arrow-dropdown'
            options={getOptions()}
            onChange={o => props.onSelectParameter(o.value)}
            value={getSelectedOption()}
            placeholder={props.placeholder} />
        </div>
    );
}
